// Decides whether an already-applied promo should be re-checked with the
// backend. We only re-check when the membership the promo applies to actually
// changes to something we haven't validated yet, which avoids a redundant
// second call right after applying (including trial conversions).
const shouldRevalidatePromoCode = ({
  promoCode,
  appliedDiscountCodeName,
  membershipType,
  lastValidatedMembershipType,
}) =>
  !!promoCode &&
  appliedDiscountCodeName === promoCode &&
  membershipType !== lastValidatedMembershipType

export default shouldRevalidatePromoCode
